<template>
	<div class="table-card">
		<table class="table table--default" v-if="statsData.length">
			<thead class="table__head">
				<tr class="table__row">
					<td class="table__col">№</td>
					<td class="table__col">Поставщик</td>
					<td class="table__col">Выигранных тендеров</td>
					<td class="table__col">
						<div class="sort" @click="changeSort"></div>
					</td>
				</tr>
				<tr class="table__margin">
					<td colspan="100%"></td>
				</tr>
			</thead>
			<tbody class="table__body">
				<template v-for="supplier in statsData" :key="supplier.userId" >
					<tr class="table__row">
						<td class="table__col">
							<span class="table__col-label">№</span>
							<span class="table__col-cont">№{{ supplier.number }}</span>
						</td>
						<td class="table__col">
							<span class="table__col-label">Поставщик</span>
							<span class="table__col-cont">
								<button @click="handleOpenSupplier(supplier.userId)" class="table__col-cont table__col-cont--green">
									<b>{{ supplier.companyName }} </b>
								</button>
							</span>
						</td>

						<td class="table__col ">
							<span class="table__col-label">Выигранных тендеров</span>
							<span class="table__col-cont">{{ supplier.cnt }}</span>
						</td>
						<td class="table__col">
							<div class="dots-action dots-action--right">
								<div class="dots-action__list">
									<div class="dots-action__item" @click="handleOpenStatsPopup(supplier)">Подробнее</div>
									<div class="dots-action__item" @click="downloadLink(supplier.userId)">Выгрузить статистику</div>
								</div>
							</div>
						</td>
					</tr>
					<tr class="table__margin">
						<td colspan="100%"></td>
					</tr>
				</template>
			</tbody>
		</table>
		<div v-else class="table-card__empty">Поставщики не найдены</div>
	</div>
	<transition-group name="modal">
		<StatsOffersPopup v-if="ShowStatsOffersPopup" @close="ShowStatsOffersPopup = false" :selectedSupplierOffers="selectedSupplierOffers"/>
		<SupplierPopup v-if="ShowSupplierPopup" :supplier="selectedSupplier" :canEdit="false" @close="ShowSupplierPopup = false"/>
	</transition-group>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import StatsOffersPopup from "@/components/sections/Stats/StatsOffersPopup.vue";
import SupplierPopup from "@/components/sections/Suppliers/SupplierPopup.vue";

export default {
	name: "StatsTable",
	components: {StatsOffersPopup, SupplierPopup},
	props: {
		statsData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			ShowStatsOffersPopup: false,
			ShowSupplierPopup: false,
			supplierId: 0,
			supplierOffers: [],
			selectedSupplierOffers: [],
			selectedSupplier: null
		}
	},
	methods: {
        async handleOpenSupplier(id) {
            if (!id) return
            const res = await this.requestSupplier(id);

            if (res.success) {
                this.selectedSupplier = res.data;
                this.ShowSupplierPopup = true;
            }
        },
		changeSort() {
			if(this.supplierFilter.order === 'asc') {
				this.updateFilter({order: 'desc'})
			} else {
				this.updateFilter({order: 'asc'})
			}
		},
        downloadLink(id) {
            window.open(`${window?.location?.origin}/api/tenders/stats/supplier-offers/${id}/export/excel/${this.supplierFilter.dateFrom ? `?dateFrom=${this.supplierFilter.dateFrom}&dateTo=${this.supplierFilter.dateTo}` : ''}`)
        },
		handleOpenStatsPopup(supplier) {
			this.selectedSupplierOffers = {
				name: supplier.companyName,
				id: Number(supplier.userId),
			}
			this.ShowStatsOffersPopup = true
		},
		...mapActions({
			updateFilter: 'stats/updateFilter',
			requestSupplier: 'suppliers/requestSupplier',
		})
		
	},
	computed: {
		...mapGetters({
			supplierFilter: 'stats/getSupplierFilter',
		})
	}
}
</script>


